/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import FlexHelpers from "@monsma/XDL/Helpers/flex";
import SpaceHelpers from "@monsma/XDL/Helpers/spaces";
import { HelpersGroup } from "@monsma/XDL/types";

export * from "@monsma/XDL/Helpers/screen";

const Helpers = {
    ...SpaceHelpers,
    ...FlexHelpers,
} as HelpersGroup;

export const xClass = (content: TemplateStringsArray, ...keys: any[]) => {
    const regex = /(?:([a-zA-Z]*)\:+)?([a-zA-Z]+)\-?([a-zA-Z0-9]*)/g;

    return (props: any) => {
        let match: any = null;
        const css: string[] = [];

        // eslint-disable-next-line no-cond-assign
        while ((match = regex.exec(String(content)))) {
            const [, screen, method, suffix] = match;
            if (Helpers[method]) {
                css.push(Helpers[method](props.theme.helpers, suffix || "md"));
            } else {
                throw new Error(`The helper ${method} not found.`);
            }
        }

        return css.join("");
    };
};
